import React, { useEffect, useRef } from 'react'
import { Link, usePage, useForm } from '@inertiajs/react'

import { ImFolderUpload } from 'react-icons/im'
import { IconButton, Progress } from '@material-tailwind/react'
import { MdOutlineSupervisedUserCircle } from 'react-icons/md'
import classNames from 'classnames'

import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import TableFilter from '@/Shared/TableFilter'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import CardContainer from '@/Shared/UI/CardContainer'
import StatsCard from '@/Shared/UI/StatsCard'
import { GoPencil } from 'react-icons/go'
import { getSerNo } from '@/utils'

const Index = () => {
    const {
        services,
        total_hr,
        supervisor,
        janitors,
        sewer_men,
        type,
        auth: { user }
    } = usePage().props

    const {
        data,
        meta: { links }
    } = services

    const ref = useRef()
    const buttonRef = useRef()

    const {
        data: formData,
        setData,
        post,
        progress,
        reset
    } = useForm({
        file: null,
        type
    })

    useEffect(() => {
        if (formData.file) {
            buttonRef.current.click()
        }
    }, [formData])

    function submit(e) {
        e.preventDefault()
        post(route('hr-upload'))
        ref.current.value = null
        reset()
    }

    const linkClass = classNames({
        'pointer-events-none': user.role === '0'
    })

    return (
        <div>
            <BreadCrumbs
                link={route().current()}
                title={`${type} HR`}
                subTitle="List"
            />

            <h1 className="mb-2 text-3xl font-bold">{type} HR</h1>

            {progress && (
                <Progress
                    value={progress.percentage}
                    max="100"
                    color="indigo"
                    className="my-4"
                />
            )}

            <CardContainer>
                <Link
                    href={route('hr.users', { card: 'Total HR' })}
                    className={linkClass}
                >
                    <StatsCard
                        title="Total HR"
                        value={`${total_hr[0][0]}/${total_hr[0][1]}`}
                        icon={() => <Icon name="hr" />}
                    />
                </Link>

                <Link
                    href={route('hr.users', { card: 'Supervisor' })}
                    className={linkClass}
                >
                    <StatsCard
                        title="Supervisor"
                        value={`${supervisor[0][0]}/${supervisor[0][1]}`}
                        icon={MdOutlineSupervisedUserCircle}
                    />
                </Link>

                <Link
                    href={route('hr.users', { card: 'Janitors' })}
                    className={linkClass}
                >
                    <StatsCard
                        title="Janitors"
                        value={`${janitors[0][0]}/${janitors[0][1]}`}
                        icon={() => <Icon name="janitor" />}
                    />
                </Link>

                <Link
                    href={route('hr.users', { card: 'Sewer Men' })}
                    className={linkClass}
                >
                    <StatsCard
                        title="Sewer Men"
                        value={`${sewer_men[0][0]}/${sewer_men[0][1]}`}
                        icon={() => <Icon name="sewer" />}
                    />
                </Link>
            </CardContainer>

            {user.role === '1' && (
                <div>
                    <h1 className="mb-2 text-xl font-semibold text-indigo-600">
                        DHQ {type} HR
                    </h1>

                    <div className="mb-4 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
                        <Link
                            href={route('hr.users', { card: 'Total HR', hospital: 'DHQ' })}
                        >
                            <StatsCard
                                title="Total HR"
                                value={`${total_hr[2][0]}/${total_hr[2][1]}`}
                                icon={() => <Icon name="hr" />}
                            />
                        </Link>

                        <Link
                            href={route('hr.users', { card: 'Supervisor', hospital: 'DHQ' })}
                        >
                            <StatsCard
                                title="Supervisor"
                                value={`${supervisor[2][0]}/${supervisor[2][1]}`}
                                icon={MdOutlineSupervisedUserCircle}
                            />
                        </Link>

                        <Link
                            href={route('hr.users', { card: 'Janitors', hospital: 'DHQ' })}
                        >
                            <StatsCard
                                title="Janitors"
                                value={`${janitors[2][0]}/${janitors[2][1]}`}
                                icon={() => <Icon name="janitor" />}
                            />
                        </Link>

                        <Link
                            href={route('hr.users', { card: 'Sewer Men', hospital: 'DHQ' })}
                        >
                            <StatsCard
                                title="Sewer Men"
                                value={`${sewer_men[2][0]}/${sewer_men[2][1]}`}
                                icon={() => <Icon name="sewer" />}
                            />
                        </Link>
                    </div>

                    <h1 className="mb-2 text-xl font-semibold text-indigo-600">
                        THQ {type} HR
                    </h1>

                    <div className="mb-8 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
                        <Link
                            href={route('hr.users', { card: 'Total HR', hospital: 'THQ' })}
                        >
                            <StatsCard
                                title="Total HR"
                                value={`${total_hr[1][0]}/${total_hr[1][1]}`}
                                icon={() => <Icon name="hr" />}
                            />
                        </Link>

                        <Link
                            href={route('hr.users', { card: 'Supervisor', hospital: 'THQ' })}
                        >
                            <StatsCard
                                title="Supervisor"
                                value={`${supervisor[1][0]}/${supervisor[1][1]}`}
                                icon={MdOutlineSupervisedUserCircle}
                            />
                        </Link>

                        <Link
                            href={route('hr.users', { card: 'Janitors', hospital: 'THQ' })}
                        >
                            <StatsCard
                                title="Janitors"
                                value={`${janitors[1][0]}/${janitors[1][1]}`}
                                icon={() => <Icon name="janitor" />}
                            />
                        </Link>

                        <Link
                            href={route('hr.users', { card: 'Sewer Men', hospital: 'THQ' })}
                        >
                            <StatsCard
                                title="Sewer Men"
                                value={`${sewer_men[1][0]}/${sewer_men[1][1]}`}
                                icon={() => <Icon name="sewer" />}
                            />
                        </Link>
                    </div>
                </div>
            )}

            <div className="mb-6 flex items-center justify-between">
                <div className="flex flex-row items-center gap-x-2">
                    <SearchFilter />

                    {/* {user.role === '1' && (
                        <IconButton
                            size="lg"
                            color="indigo"
                            className="h-8"
                            onClick={() => ref.current.click()}
                        >
                            <form onSubmit={submit} className="hidden">
                                <input
                                    type="file"
                                    name="file"
                                    accept=".xls,.xlsx"
                                    ref={ref}
                                    onChange={e => setData('file', e.target.files[0])}
                                />

                                <button type="submit" ref={buttonRef}>
                                    Submit
                                </button>
                            </form>
                            <ImFolderUpload size={20} className="cursor-pointer" />
                        </IconButton>
                    )} */}
                </div>

                <div className="flex items-center gap-x-4">
                    <TableFilter exportRoute="hr.export" />

                    {user.role === '1' ? (
                        <Link
                            className="btn-indigo focus:outline-none"
                            href={route('hr.create', String(type).toLowerCase())}
                        >
                            <span>Add HR</span>
                            <span className="hidden md:inline"> Record</span>
                        </Link>
                    ) : data.length > 0 ? (
                        <Link
                            className="btn-indigo focus:outline-none"
                            href={route('hr.user.create', data[0].id)}
                        >
                            <span>Add HR</span>
                            <span className="hidden md:inline"> Designation</span>
                        </Link>
                    ) : null}
                </div>
            </div>
            <div className="overflow-x-auto rounded bg-white shadow">
                <table className="table-auto">
                    <thead className="text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr className="text-left font-bold">
                        <th className="px-6 pb-4 pt-5 whitespace-nowrap">Sr No.</th>
                        <th className="px-6 pb-4 pt-5">Hospital</th>
                        <th className="px-6 pb-4 pt-5">District</th>
                        <th className="px-6 pb-4 pt-5">Division</th>
                        <th className="px-6 pb-4 pt-5">Beds</th>
                        <th className="px-6 pb-4 pt-5">Package</th>
                        <th className="px-6 pb-4 pt-5">Firm</th>
                        <th className="px-6 pb-4 pt-5">HR to be deployed per day per Hospital</th>
                        <th className="px-6 pb-4 pt-5">Total HR required including relievers per Hospital</th>
                        <th className="px-6 pb-4 pt-5">Supervisor</th>
                        <th className="px-6 pb-4 pt-5">Available Supervisor</th>
                        <th className="px-6 pb-4 pt-5">Janitors</th>
                        <th className="px-6 pb-4 pt-5">Available Janitors</th>
                        <th className="px-6 pb-4 pt-5">Sewer men</th>
                        <th className="px-6 pb-4 pt-5">Available Sewer men</th>
                        <th className="px-6 pb-4 pt-5">Total</th>
                        <th className="px-6 pb-4 pt-5">Available Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.map(
                        (
                            {
                                id,
                                hospital_name,
                                hospital_id,
                                district,
                                division,
                                beds,
                                package_name,
                                firm,
                                per_day,
                                total_required,
                                supervisor,
                                available_supervisor,
                                janitors,
                                available_janitors,
                                sewer_men,
                                available_sewer_men,
                                total,
                                available_total,
                                deleted_at
                            },
                            index
                        ) => {
                            return (
                                <tr
                                    key={id}
                                    className="focus-within:bg-gray-100 hover:bg-gray-100"
                                >
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {getSerNo(links, index)}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={
                                                user.role === '1'
                                                    ? route('hr.hospital', {
                                                        service: String(type).toLowerCase(),
                                                        hospital: hospital_id
                                                    })
                                                    : route('hr.designations', {
                                                        service: type.toLowerCase(),
                                                        hr: id
                                                    })
                                            }
                                            className="focus:text-indigo whitespace-nowrap flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {hospital_name}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {district}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {division}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                                        >
                                            {beds}
                                            {deleted_at && (
                                                <Icon
                                                    name="trash"
                                                    className="ml-2 h-3 w-3 flex-shrink-0 fill-current text-gray-400"
                                                />
                                            )}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={
                                                user.role === '1'
                                                    ? route('hr.package', {
                                                        service: type.toLowerCase(),
                                                        package: package_name
                                                    })
                                                    : route('hr.designations', {
                                                        service: type.toLowerCase(),
                                                        hr: id
                                                    })
                                            }
                                            className="focus:text-indigo whitespace-nowrap flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {package_name}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={
                                                route('hr.designations', {
                                                    service: type.toLowerCase(),
                                                    hr: id
                                                })
                                            }
                                            className="focus:text-indigo whitespace-nowrap flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {firm}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {per_day}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {total_required}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {supervisor}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {available_supervisor}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {janitors}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {available_janitors}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {sewer_men}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {available_sewer_men}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {total}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('hr.designations', {
                                                service: type.toLowerCase(),
                                                hr: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {available_total}
                                        </Link>
                                    </td>
                                    {user.role === '1' && (
                                        <td className="w-px border-t p-4">
                                            <Link
                                                tabIndex="-1"
                                                href={route('hr.edit', {
                                                    service: type.toLowerCase(),
                                                    hr: id
                                                })}
                                                className="flex border rounded-lg gap-x-2 text-indigo-600 font-semibold items-center px-3 py-2 focus:outline-none"
                                            >
                                                <GoPencil
                                                    className="block h-4 w-4 fill-current text-indigo-400"
                                                />
                                                Edit
                                            </Link>
                                        </td>
                                    )}
                                </tr>
                            )
                        }
                    )}
                    {data.length === 0 && (
                        <tr>
                            <td className="border-t px-6 py-4" colSpan="4">
                                No record found.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
            <Pagination links={links} />
        </div>
    )
}

Index.layout = page => <Layout title="HR" children={page} />

export default Index
